module.exports = __webpack_public_path__ + "static/media/page09_front_with_bg.3e65a834.gif";